import { useState } from 'react';

export default function LiveSite() {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <section id="live-site" className="py-16 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <div className="inline-block px-4 py-2 bg-green-100 text-green-700 text-sm font-semibold rounded-full mb-6 whitespace-nowrap">
            Live Preview
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
            Experience <span className="text-green-600">The Owner Press</span> Live
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Explore our live news platform and see how we deliver truth-driven journalism to readers worldwide.
          </p>
        </div>

        {/* Creative Frame Design */}
        <div className="relative">
          {/* Decorative Elements */}
          <div className="absolute -top-6 -left-6 w-24 h-24 bg-green-100 rounded-2xl -z-10"></div>
          <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-green-600 rounded-2xl -z-10"></div>
          
          {/* Main Frame */}
          <div className="relative bg-gradient-to-br from-gray-900 to-black rounded-3xl p-4 shadow-2xl">
            {/* Browser Chrome */}
            <div className="bg-gray-800 rounded-t-2xl px-4 py-3 flex items-center gap-2 mb-1">
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                <div className="w-3 h-3 bg-green-400 rounded-full"></div>
                <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                <div className="w-3 h-3 bg-green-400 rounded-full"></div>
                <div className="w-3 h-3 bg-green-600 rounded-full"></div>
              </div>
              <div className="flex-1 mx-4">
                <div className="bg-gray-700 rounded-lg px-4 py-2 flex items-center gap-2">
                  <i className="ri-lock-line text-xs text-gray-400"></i>
                  <span className="text-xs text-gray-300 font-medium">theownerpress.com</span>
                </div>
              </div>
            </div>

            {/* Iframe Container */}
            <div className="relative bg-white rounded-b-2xl overflow-hidden" style={{ height: '700px' }}>
              {isLoading && (
                <div className="absolute inset-0 flex items-center justify-center bg-gray-50 z-10">
                  <div className="text-center">
                    <div className="w-16 h-16 border-4 border-green-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
                    <p className="text-base text-gray-600 font-medium">Loading The Owner Press...</p>
                  </div>
                </div>
              )}
              <iframe
                src="https://theownerpress.com"
                className="w-full h-full border-0"
                title="The Owner Press Live Site"
                onLoad={() => setIsLoading(false)}
                sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
              />
            </div>
          </div>

          {/* Info Cards */}
          <div className="grid md:grid-cols-3 gap-6 mt-12">
            <div className="bg-gray-50 rounded-xl p-6 border-l-4 border-green-600">
              <div className="flex items-center gap-3 mb-3">
                <i className="ri-global-line text-2xl text-green-600"></i>
                <h3 className="text-lg font-bold text-gray-900">Live Platform</h3>
              </div>
              <p className="text-sm text-gray-600 leading-relaxed">Access real-time news and updates from our network of independent journalists.</p>
            </div>
            <div className="bg-gray-50 rounded-xl p-6 border-l-4 border-green-600">
              <div className="flex items-center gap-3 mb-3">
                <i className="ri-newspaper-line text-2xl text-green-600"></i>
                <h3 className="text-lg font-bold text-gray-900">Latest Stories</h3>
              </div>
              <p className="text-sm text-gray-600 leading-relaxed">Browse breaking news, investigative reports, and in-depth analysis from our reporters.</p>
            </div>
            <div className="bg-gray-50 rounded-xl p-6 border-l-4 border-green-600">
              <div className="flex items-center gap-3 mb-3">
                <i className="ri-shield-check-line text-2xl text-green-600"></i>
                <h3 className="text-lg font-bold text-gray-900">Verified Content</h3>
              </div>
              <p className="text-sm text-gray-600 leading-relaxed">Every article is fact-checked and verified to meet our highest ethical standards.</p>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-16 text-center">
          <a 
            href="https://theownerpress.com" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-4 bg-green-600 text-white text-base font-semibold rounded-full hover:bg-green-700 transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
          >
            <span>Visit The Owner Press</span>
            <i className="ri-external-link-line text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}